export type WorkspaceDevice = "phone" | "tablet";

export interface WorkspaceDeviceSpec {
  width: number;
  height: number;
  radius: number;
  bezel: number;
  maxScale: number;
  label: string;
}

export const HEADER_HEIGHT = 60;
export const FOOTER_HEIGHT_WITH_COMMENT_BAR = 76;
export const FOOTER_HEIGHT_PLAIN = 44;
export const MODULE_GAP = 12;
export const PAGE_PADDING = 0;

export const VIEWER_SPLIT_MIN_WIDTH = 1024;
export const VIEWER_MODULE_COLUMN_MIN = 380;
export const VIEWER_MODULE_COLUMN_RATIO = 0.38;
export const VIEWER_MODULE_COLUMN_MAX = 480;
export const VIEWER_STACK_MAX_WIDTH = 560;
export const VIEWER_DETAIL_PADDING_X = 40;
export const VIEWER_DETAIL_PADDING_Y = 32;
export const VIEWER_DETAIL_IMAGE_MAX_HEIGHT_PERCENT = 50;
export const VIEWER_DETAIL_SECTION_GAP = 20;
export const VIEWER_DETAIL_PANEL_PADDING = 20;
export const VIEWER_DETAIL_PANEL_COLUMN_GAP = 24;
export const VIEWER_DETAIL_TOC_SCROLL_MARGIN = 12;

export const WORKSPACE_DEVICES: Record<WorkspaceDevice, WorkspaceDeviceSpec> = {
  phone: { width: 390, height: 844, radius: 34, bezel: 8, maxScale: 0.85, label: "Phone" },
  tablet: { width: 1180, height: 820, radius: 20, bezel: 10, maxScale: 0.75, label: "Tablet" },
};
export const PHONE_PREVIEW_SCALE = 0.6;

export const WORKSPACE_PANEL_WIDTH = 264;
export const WORKSPACE_INSPECTOR_WIDTH = 360;
export const WORKSPACE_SECONDARY_PANEL_WIDTH = 284;

export const MIN_CHART_WIDTH = 320;

export const CHART_PLOT_HEIGHT = {
  area: 260,
  bar: 260,
  candlestick: 300,
  funnel: 320,
  heatmap: 240,
  line: 220,
  metricTabs: 200,
  profitLoss: 260,
  quadrant: 480,
  quadrantCollapsed: 290,
  radialBar: 240,
  sankey: 300,
  scatter: 300,
} as const;

export const CHART_PLOT_WIDTH = {
  quadrant: 720,
  radialBar: 280,
  sankey: 620,
} as const;

export const CHART_SQUARE_SIZE = {
  pie: 260,
  radar: 340,
  sunburst: 360,
} as const;

export const MIN_PX_PER_POINT = {
  area: 56,
  bar: 56,
  candlestick: 40,
  line: 56,
  profitLoss: 48,
  scatter: 48,
  heatmap: 16,
} as const;

export const DATA_TABLE_ROWS_PER_PAGE = 8;
export const DATA_TABLE_SEARCH_TRACK_DELAY_MS = 800;
export const FEATURE_COMPARISON_ROWS_PER_PAGE = 6;
export const FEATURE_COMPARISON_LABEL_COLUMN_WIDTH = 220;
export const FEATURE_COMPARISON_PLAN_COLUMN_WIDTH = 160;
export const DUAL_METRIC_TICK_SEGMENTS = 30;

export const RING_KPI_TILE_MIN_WIDTH = "13rem";
export const RING_KPI_RING_SIZE = 40;
export const RING_KPI_RING_THICKNESS = 4;
export const RING_KPI_RING_SEGMENTS = 14;
export const RING_KPI_RING_GAP_DEG = 7;
